<template>
  <div class="contacts-form">
    <form
      v-show="formResult === 'form'"
      @submit.prevent="$_sendForm"
      class="contacts__form">

      <div v-placeholder class="contacts__form__element">
        <div class="contacts__form__element__placeholder">{{ $t('forms.name') }}</div>
        <input
          v-model="name"
          :class="{ 'errorinput': errors.has('name')}"
          name="name"
          type="text"
          v-validate="'required'">
        <span class="contacts__form__element_error">{{ errors.first('name') }}</span>
      </div>
      <div v-placeholder class="contacts__form__element">
        <div class="contacts__form__element__placeholder">{{ $t('forms.surname') }}</div>
        <input
          v-model="surname"
          :class="{ 'errorinput': errors.has('surname')}"
          name="surname"
          type="text"
          v-validate="'required'">
        <span class="contacts__form__element_error">{{ errors.first('surname') }}</span>
      </div>
      <div v-placeholder class="contacts__form__element">
        <div class="contacts__form__element__placeholder">{{ $t('forms.profession') }}</div>
        <select
          v-model="profession"
          :class="{ 'errorinput': errors.has('profession')}"
          name="profession"
          v-validate="'required'">
          <option :key="$t('forms.stockist')" :value="$t('forms.stockist')">{{ $t('forms.stockist') }}</option>
          <option :key="$t('forms.transformer')" :value="$t('forms.transformer')">{{ $t('forms.transformer') }}</option>
          <option :key="$t('forms.barman_restaurateur')" :value="$t('forms.barman_restaurateur')">{{ $t('forms.barman_restaurateur') }}</option>
          <option :key="$t('forms.other')" :value="$t('forms.other')">{{ $t('forms.other') }}</option>
        </select>
        <span class="contacts__form__element_error">{{ errors.first('profession') }}</span>
      </div>
      <div v-placeholder class="contacts__form__element">
        <div class="contacts__form__element__placeholder">{{ $t('forms.city') }}</div>
        <input
          v-model="city"
          :class="{ 'errorinput': errors.has('city')}"
          name="city"
          type="text"
          v-validate="'required'">
        <span class="contacts__form__element_error">{{ errors.first('city') }}</span>
      </div>
      <div v-placeholder class="contacts__form__element">
        <div class="contacts__form__element__placeholder">{{ $t('forms.email') }}</div>
        <input
          v-model="email"
          :class="{ 'errorinput': errors.has('email')}"
          name="email"
          type="text"
          v-validate="'required|email'">
        <span class="contacts__form__element_error">{{ errors.first('email') }}</span>
      </div>
      <div v-placeholder class="contacts__form__element">
        <div class="contacts__form__element__placeholder">{{ $t('forms.telephone') }}</div>
        <input
          v-model="telephone"
          :class="{ 'errorinput': errors.has('telephone')}"
          name="telephone"
          type="text"
          v-validate="'required'">
        <span class="contacts__form__element_error">{{ errors.first('telephone') }}</span>
      </div>
      <div v-placeholder class="contacts__form__element contacts__form__element--textarea">
        <div class="contacts__form__element__placeholder">{{ $t('forms.message') }}</div>
        <input
          v-model="message"
          :class="{ 'errorinput': errors.has('message')}"
          name="message"
          type="text"
          v-validate="'required'">
        <span class="contacts__form__element_error">{{ errors.first('message') }}</span>
      </div>
      <div v-placeholder class="contacts__form__element contacts__form__element--checkbox">
        <div class="custom-checkbox" :class="{ 'errorinput': errors.has('privacy')}">
          <p style="text-decoration: none">{{ $t('forms.articles') }}</p>
          <input v-model="privacy" v-validate="'required'" name="privacy" type="checkbox" id="privacy_check"/>
          <label for="privacy_check">{{ $t('forms.privacyText01') }} <router-link :to="{ name: `${lang}.single-page`, params: { slug: 'privacy-policy' } }">Privacy Policy</router-link> {{ $t('forms.privacyText02') }}</label>
          <span class="contacts__form__element_error">{{ errors.first('privacy') }}</span>
        </div>
        <div class="custom-checkbox">
          <input v-model="newsletter" name="newsletter" type="checkbox" id="newsletter-c"/>
          <label for="newsletter-c">{{ $t('forms.privacyText03') }}</label>
          <p>{{ $t('forms.privacyText04') }}</p>
        </div>
      </div>
      <div class="contacts__form__element contacts__form__element--send-button">
        <button :class="{'contacts__form__element--send-button--enabled': buttonEnabled}">{{ $t('forms.send') }}</button>
      </div>
    </form>
    <div
      v-show="formResult === 'success'"
      class="contacts-form__results">
      <h3 v-html="$t('forms.successTitle')"></h3>
      <p v-html="$t('forms.successText')"></p>
    </div>
    <div
      v-show="formResult === 'failure'"
      class="contacts-form__results">
      <h3 v-html="$t('forms.failureTitle')"></h3>
      <p v-html="$t('forms.failureText')"></p>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import axios from 'axios'
import { load } from 'recaptcha-v3'

export default {
  name: 'ContactsForm',
  data: () => ({
    name: '',
    surname: '',
    profession: '',
    city: '',
    email: '',
    telephone: '',
    message: '',
    privacy: '', // privacy.repeat(20),
    newsletter: false,
    token: '',
    formResult: 'form',
    buttonEnabled: true
  }),
  computed: {
    ...mapGetters([
      'lang'
    ])
  },
  methods: {
    $_validateBeforeSubmit () {
      return this.$validator.validateAll()
    },
    async $_sendForm () {
      // validate inputs
      const validated = await this.$_validateBeforeSubmit()
      if (validated) {
        // load recaptcha token
        if (this.buttonEnabled) {
          this.buttonEnabled = false
          const recaptcha = await load('6Lftjp0UAAAAAFrIzwIo0-aMdMG7DGEqWylmpNLx')
          this.token = await recaptcha.execute('homepage')
          if (typeof this.token !== 'undefined') {
            const submissionResult = await this.$_post({
              name: this.name,
              surname: this.surname,
              profession: this.profession,
              city: this.city,
              email: this.email,
              telephone: this.telephone,
              message: this.message,
              newsletter: this.newsletter, // boolean,
              token: this.token
            })
            if (submissionResult) this.formResult = 'success' // success
            else this.formResult = 'failure' // failure
          }
          // subscribe to mailchimp
          if (!this.newsletter) return
          this.$_mailchimpSubscribe()
        }
      }
    },
    async $_mailchimpSubscribe () {
      try {
        const list = this.lang === 'it' ? process.env.VUE_APP_MAILCHIMP_LIST_ID_IT : process.env.VUE_APP_MAILCHIMP_LIST_ID_EN
        const mailchimp = await axios.post(`https://europe-west1-glaxi-6c4fe.cloudfunctions.net/mailchimp/list/${list}/members/create`,
          {
            emailAddress: this.email,
            status: 'subscribed',
            mergeFields: {
              'FNAME': this.name,
              'LNAME': this.surname,
              'MMERGE5': this.company,
              'PHONE': this.telephone
            }
          }
        )
        if (mailchimp.status === 'pass') return true
        return false
      } catch (err) {
        return false
      }
    },
    async $_post (postData) {

      
     /* const apiId = this.lang === 'it' ? '903b72cd-20f5-4957-82fc-7c1a09fbaa43' : '6bdf6f5d-c67f-49f0-9a97-3348caa641fc'
      
        if (typeof postData.token !== 'undefined') {
          try {
            const formData = new FormData()
            
            formData.append('captcha', postData.token)
            formData.append('api_id', apiId)
            formData.append('name', postData.name)
            formData.append('surname', postData.surname)
            formData.append('telephone', postData.telephone)
            formData.append('city', postData.city)
            formData.append('profession', postData.profession)
            formData.append('email', postData.email)
            formData.append('message', postData.message)
            formData.append('newsletter', postData.newsletter)
            const sendMail = await axios.post('https://qpostin.herokuapp.com/emails/', formData)
            // console.log(sendMail)
            if (sendMail.status === 200) {
              
              return true
            }
            
            return false
          } catch (err) {
            // console.log('sendMail', err)
            
            return false
          }
        }*/



      // recupero la lingua
     var submittedLang = this.lang === 'it' ? 'it' : 'en-US'
      try {
        const validateRecaptcha = await axios.post('https://europe-west1-glaxi-6c4fe.cloudfunctions.net/recaptcha/validate', {
          fields: {
            title: {
              [submittedLang]: postData.email + ' on ' + new Date().toUTCString()
            },
            name: {
              [submittedLang]: postData.name
            },
            surname: {
              [submittedLang]: postData.surname
            },
            profession: {
              [submittedLang]: postData.profession
            },
            city: {
              [submittedLang]: postData.city
            },
            email: {
              [submittedLang]: postData.email
            },
            telephone: {
              [submittedLang]: postData.telephone
            },
            message: {
              [submittedLang]: postData.message
            },
            newsletter: {
              [submittedLang]: postData.newsletter
            }
          },
          context: {
            token: postData.token,
            model: 'contacts'
          }
        })
        if (validateRecaptcha.data.status === 'pass') return true
        return false
      } catch (err) {
        console.log('validateRecaptcha', err)
        return false
      }
    }
  },
  directives: {
    placeholder: {
      bind (el) {
        el.classList.add('contacts__form__element--show-placeholder')

        const input = el.querySelector('input, select')
        if (input !== null) {
          input.addEventListener('focus', () => {
            el.classList.add('contacts__form__element--hide-placeholder')
          })

          input.addEventListener('blur', () => {
            if (input.value.trim() === '') {
              el.classList.remove('contacts__form__element--hide-placeholder')
            } else {
              el.classList.add('contacts__form__element--hide-placeholder')
            }
          })
        }
      }
    }
  },
  watch: {
    formResult (newVal, oldVal) {
      document.querySelector('html,body').scrollTop = 0
    }
  }
}
</script>

<style lang="scss">
  @import "./forms.scss";
</style>
